import { Card } from '@george-labs.com/design-system';
import type { FC, ReactNode } from 'react';

import { ErrorBoundary } from './ErrorBoundary';
import { UnknownError } from './UnknownError';

interface Props {
    children: ReactNode;
}
export const ErrorBoundaryInCard: FC<Props> = ({ children }) => (
    <ErrorBoundary
        errorContent={
            <Card>
                <UnknownError />
            </Card>
        }
    >
        {children}
    </ErrorBoundary>
);
